import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70e1a1ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "media-pager" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode("分页"),
    _createVNode(_component_el_pagination, {
      class: "pagination",
      "current-page": $setup.pagerPage,
      "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => (($setup.pagerPage) = $event)),
      "page-size": $setup.pageSize,
      "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => (($setup.pageSize) = $event)),
      "default-current-page": 1,
      "page-sizes": $setup.pageSizes,
      "pager-count": $setup.pageCount,
      small: $setup.pageSmall,
      disabled: $setup.disabled,
      background: $setup.background,
      layout: $setup.pageLayout,
      total: $setup.props.count,
      onSizeChange: $setup.size_change,
      onCurrentChange: $setup.page_change
    }, null, 8 /* PROPS */, ["current-page", "page-size", "page-sizes", "pager-count", "small", "disabled", "background", "layout", "total"])
  ]))
}